import React from 'react';
import Link from '../Link';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import styles from './styles.module.scss';

type BotonVerTodoProps = {
    href: string
    children: React.ReactNode
}

const BotonVerTodo = ({ href, children }: BotonVerTodoProps) => {
  return (
    <div className={styles.wrapper}>
      <Link href={href} className={styles.boton}>
        {children}
        <ArrowForwardIcon className={styles.icono} />
      </Link>
    </div>
  );
};

export default BotonVerTodo;
